import { IWprModeBool } from '../inter/IWprModeBool';
import { WprBaseValueModeSetter } from './WprBaseValueModeSetter';
import { IWprConfigModeOption } from '../inter/IWprConfigModeOption';
import { WprBaseViewMode } from '../WprBaseViewMode';

/**
 * モード表示状態設定
 */
export class WprDisplayModeSetter extends WprBaseValueModeSetter<IWprModeBool> {
	// コンストラクタ  -----------------------------------------------------------
	public constructor(option: IWprConfigModeOption, viewMoode: WprBaseViewMode) {
		super('display', option, viewMoode);
	}
	// --------------------------------------------------------------------------

	// override メソッド	-----------------------------------------------------
	/**
	 * 初期化処理
	 * @param option モード定義オプション
	 */
	public initialize(): void {
		this.initializeModeList(this.option.display);
	}

	/**
	 * コントロールステータス設定処理
	 * @param vinfo 値情報
	 */
	public setControlStatus(vinfo: IWprModeBool): void {
		this.controlInfo.setDisplay(vinfo.value);
	}
	// --------------------------------------------------------------------------
}
